const BASE = '/v3/api/nps'

export const endpoint = {
  elegibilidade: BASE + '/elegibilidade',
  resposta: BASE + '/resposta',
  comentario: function (id) {
    return BASE + '/resposta/' + id
  },
  dispensa: BASE + '/dispensa',
}
